import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import queryString from 'query-string';


import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    DateTimePicker
} from '@material-ui/pickers';

export function MaterialUIPickers(props) {
    var firstDay = new Date();
    const [selectedDate, setSelectedDate] = React.useState(firstDay);
    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container>
                    <DateTimePicker
                disableToolbar
                variant="inline"
                margin="normal"
                id={props.id}
                value={selectedDate}
                onChange={handleDateChange}
                    autoOk={true}
                    keyboardbuttonprops={{
                    'aria-label': 'change date'
                }}
                />
                </Grid>
        </MuiPickersUtilsProvider>
    );
}


class ProfileWalletWithdraw extends React.Component {
    _isMounted = false;

    state = {
        loading: false,
        alert: 0,
        alertMessage: '',
        backArrow: false,
        flag: 0,
        SelectedAccountNumber: '',
        withdrawAmount: '',
        orderId: this.makeRandomId(10),
        Date: dateFormatUtil(new Date()),
        remarks: '',
        Beneficiary: [],
        benfList: [],
        ShowFlashMessage: false,
        FlashMessage: '',
        transactionCharges: 2.5,
        profileDocId:'',
    };

    
    async componentDidMount() {
        this._isMounted = true;
        

        
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    async updateCashFreeWallet(bodyData, reload = false) {
        await RestServices.updateCashFreeWallet(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 4,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    

    

    onChangeValues = (event) => {
    if(event.target.type === 'number' ){
		if (Number.isNaN(Number.parseFloat(event.target.value))) {
            this.setState({ [event.target.name]: 0 });
		}else{
		 this.setState({ [event.target.name]: parseFloat(event.target.value) });
		}
        
    }else{
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
        
    }
    };

    async ReleaseNow() {
        if (this._isMounted) {
            this.setState({
                loading:true
            });
        }
        
        if (this.state.withdrawAmount < 1) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    loading:false,
                    alertMessage: 'Please add valid amount to debit'
                });
            }
        } else {
           
            let orderToken =
                this.props.UniqeID + '-W-' + this.makeRandomId(5);
            let bodyData = {
            customerId: this.props.userProfileDocId,
            orderId:  this.makeRandomId(15),
            orderToken: orderToken,
            amount: this.state.withdrawAmount,
            status: 'SUCCESS',
            type: 'Debit',
            AddedTimeStamp: this.state.Date,
            UpdatedBy: this.props.user.profileDocId,
            EmpID: this.props.user.ProfileUniqeID,
            userRole: this.props.role,
            Description: this.state.remarks,
            Provider:'Manual',
            method:'direct',
            commission:0
           };
           
           
           await RestServices.updateCashFreeWallet(
            localStorage.getItem('FirebaseToken'),
            bodyData
         )
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.status === 'SUCCESS'){
                    this.props.afterWithdraw()
                    if (this._isMounted) {
                        this.setState({
                            alert: 5,
                            alertMessage: 'Rs.'+this.state.withdrawAmount+' Debited from wallet...',
                            loading:false,
                            withdrawAmount: '',
                            orderId: this.makeRandomId(10),
                        });
                    }
                    

                }else{
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error,
                            loading:false,
                            withdrawAmount: '',
                            Date: dateFormatUtil(new Date()),
                            remarks:'',
                            orderId: this.makeRandomId(10),
                        });
                    }

                }
                
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        alert: 1,
                        alertMessage: err.message,
                        loading:false,
                    });
                }
            });
            
    
    }
    }

    makeRandomId(length) {
        var result = '';
        var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    setWithDarAmount = (event) => {
        
        if (parseFloat(event.target.value) > parseFloat(this.props.currentTotalBalance)) {
            this.setState({ [event.target.name]: parseFloat(this.props.currentTotalBalance).toFixed(0) });
        }else{
            this.setState({ [event.target.name]: event.target.value });  
        }
    }

    
    render() {
        return (
            <div>
                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                
                {this.state.alert === 5 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                    <div>
                        
                        <Form.Group>
                            <Form.Label>Enter Amount to Withdraw</Form.Label>
                            <Form.Control
                                value={this.state.withdrawAmount}
                                onChange={this.setWithDarAmount}
                                name="withdrawAmount"
                                type="number"
                                placeholder="Enter Amount"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Enter Notes (optional)</Form.Label>
                            <Form.Control
                                value={this.state.remarks}
                                onChange={this.onChangeValues}
                                name="remarks"
                                type="text"
                                placeholder="Enter remarks"
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Transaction Date/Time</Form.Label>
                            <MaterialUIPickers
                                id="transaction_date"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        Date: dateFormatUtil(date)
                                    });
                                }}
                            />
                        </Form.Group>

                        <Form.Group>
                        {!this.state.loading && <Button
                                onClick={(e) => {
                                    this.ReleaseNow();
                                }}
                                style={{
                                    marginLeft: '0.5rem',
                                    marginTop: '0.3rem'
                                }}
                            >
                                Submit
                            </Button>}
                        </Form.Group>
                    </div>
                
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ProfileWalletWithdraw);
